import TabElement from 'Components/Element/TabElement';
import Tabs from 'Components/Element/Tabs';
import Template from 'Components/Templates/Template';
import { Context } from 'Context/Context';
import React, { useContext, useState } from 'react'

function AnalyticsHorizontalTab({tabs, activeTab, setActiveTab }) {
    const {userDetails} = useContext(Context);
    const {notification} = userDetails ? userDetails : "";
    const count = notification?.filter((msg) => msg?.is_read === false).length;
    tabs?.map((item) => item.name === "Notifications" ? item.count = count : 0);
  
    return (
           <div className='flex font-medium items-center text-sm w-full ml-30 border-b bg-[#f9f9f9] z-10'>
            {
              tabs?.map((item, key) => (
            
                <TabElement 
                activeTab={activeTab} 
                setActiveTab={setActiveTab} 
                id={key} 
                name={item.name}
                onClick={() => {setActiveTab(key)}}
                />
              ))
            }
          </div>
    )
}

export default AnalyticsHorizontalTab